import { render } from "./chamado.vue?vue&type=template&id=22ce4b52&scoped=true"
import script from "./chamado.vue?vue&type=script&lang=js"
export * from "./chamado.vue?vue&type=script&lang=js"

import "./chamado.vue?vue&type=style&index=0&id=22ce4b52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ce4b52"]])

export default __exports__